import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { XsI18nPipe } from '@nx-fe/pipes';

export interface DirtyComponent {
  canDeactivate: () => boolean;
  deactivateMessage: () => string;
}

@Injectable({
  providedIn: 'root',
})
export class DirtyCheckGuard implements CanDeactivate<DirtyComponent> {
  constructor(
    private xsI18nPipe: XsI18nPipe,
  ) {}

  canDeactivate(component: DirtyComponent): boolean {
    if (component.canDeactivate()) {
      return confirm(this.xsI18nPipe.transform(component.deactivateMessage()));
    }
    return true;
  }
}
